<template>
  <div>
    <transition name="fade">
      <div class="scroll-to-top" @click="scroll" v-if="scrolled">
        <div class="arrow">
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
  export default {
    name: 'ScrollToTop',
    data () {
      return {
        scrolled: false
      }
    },
    methods: {
      scroll () {
        window.scrollTo(0, 0)
      },
      handleScroll () {
        this.scrolled = window.scrollY > 200
      }
    },
    created () {
      window.addEventListener('scroll', this.handleScroll)
    },
    destroyed () {
      window.removeEventListener('scroll', this.handleScroll)
    }
  }
</script>

<style scoped lang="scss">
  .scroll-to-top {
    width: 50px;
    height: 50px;
    position: fixed;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.005);
    cursor: pointer;
    padding: 30px;
    z-index: 100;
    &:hover {
      background-color: rgba(0, 0, 0, 0.02);
    }
    .arrow {
      margin: 0 auto;
      width: 30px;
      height: 30px;
      border-top: 1px solid $blue;
      border-left: 1px solid $blue;
      transform: rotate(45deg);
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ScrollToTop.vue